import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { withLatestFrom } from 'rxjs';

import { AppStoreState } from '@core/interfaces/app-store-state';

import * as NotaryRequestActions from './notary-request-actions';
import { notaryRequestSelector } from './notary-request-selector';

@Injectable()
export class NotaryRequestEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject<Store<AppStoreState>>(Store);

  readonly updateAction$ = createEffect(
    () =>
      this.actions$.pipe(ofType(NotaryRequestActions.SELECT), withLatestFrom(this.store.select(notaryRequestSelector))),
    { dispatch: false }
  );
}
